import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { EntryApiAdapter } from '../../adapters/EntryApiAdapter';
import { CreateEntryAPIData } from '../models/CreateEntrySchema';

export const useCreateEntry = () => {
  const queryClient = useQueryClient();
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new EntryApiAdapter(httpClient);

  return useMutation({
    mutationFn: (data: CreateEntryAPIData) => apiAdapter.createEntry(data),
    onSuccess: () => {
      // Invalidar todas las queries de entries para actualizar la lista
      queryClient.invalidateQueries({ queryKey: ['merchandise-v3-entries'] });
    },
  });
};

